import { Vector2i, VRect, GetValues_ForSchema, GetEntries } from "js-vextensions";
import { Button, ColorPickerBox, Pre, Row, RowLR, Select, Spinner } from "react-vcomponents";
import { BaseComponent } from "react-vextensions";
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { CompUI_splitAt, CompUI_width } from "UI/Write/MapUI/Panels/ObjectPanel";
import { CompUIWrapper } from "UI/Write/MapUI/Panels/ObjectPanel/General";
import { store } from "Store";
import { runInAction } from "mobx";
import { AddSchema } from "mobx-firelink";
export class ShapeComp {
    constructor(initialData) {
        this.Extend(initialData);
    }
    InitShape(firstPoint) {
        if (this.type == ShapeType.Rectangle) {
            this.rect = new VRect(firstPoint, new Vector2i());
        }
        else if (this.type == ShapeType.Region) {
            this.pathPoints = [firstPoint];
        }
        else if (this.type == ShapeType.Path) {
            this.pathPoints = [firstPoint];
            this.thickness = this.thickness || 1;
            this.thicknessUnit = this.thicknessUnit || DistanceUnit.Pixels;
        }
    }
}
AddSchema("ShapeComp", {
    properties: {
        type: { $ref: "ShapeType" },
        color: { type: "string" },
        rect: { $ref: "VRect" },
        pathPoints: { items: { $ref: "Vector2i" } },
        thickness: { type: "number" },
        thicknessUnit: { $ref: "DistanceUnit" },
    },
});
export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Rectangle"] = 10] = "Rectangle";
    ShapeType[ShapeType["Region"] = 20] = "Region";
    ShapeType[ShapeType["Path"] = 30] = "Path";
})(ShapeType || (ShapeType = {}));
AddSchema("ShapeType", { oneOf: GetValues_ForSchema(ShapeType) });
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit[DistanceUnit["Meters"] = 10] = "Meters";
    DistanceUnit[DistanceUnit["Pixels"] = 20] = "Pixels";
})(DistanceUnit || (DistanceUnit = {}));
AddSchema("DistanceUnit", { oneOf: GetValues_ForSchema(DistanceUnit) });
export class ShapeCompUI extends BaseComponent {
    render() {
        const { obj } = this.props;
        return (React.createElement(CompUIWrapper, { obj: obj, compProp: "shape" },
            obj.shape.type == ShapeType.Path
                && React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                    React.createElement(Pre, null, "Thickness: "),
                    React.createElement(Row, { style: { width: "100%" } },
                        React.createElement(Spinner, { step: .01, style: { minWidth: 0 }, value: obj.shape.thickness, onChange: val => {
                                const updates = { shape: obj.shape.Extended({ thickness: val }) };
                                new UpdateMapObject({ id: obj._key, updates }).Run();
                            } }),
                        React.createElement(Select, { options: GetEntries(DistanceUnit), value: obj.shape.thicknessUnit, onChange: val => {
                                const updates = { shape: obj.shape.Extended({ thicknessUnit: val }) };
                                new UpdateMapObject({ id: obj._key, updates }).Run();
                            } }))),
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(Pre, null, "Color: "),
                React.createElement(ColorPickerBox, { color: obj.shape.color || "255,0,0,1", onChange: color => {
                        const updates = { shape: obj.shape.Extended({ color }) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } })),
            React.createElement(Button, { text: "Redraw shape", onClick: () => {
                    runInAction("RedrawShape", () => {
                        //SetCurrentMapTool("DrawShape");
                        store.main.write.tools.drawShape.targetObject = obj._key;
                        store.main.write.selectedTool = "DrawShape";
                    });
                } }),
            [ShapeType.Region, ShapeType.Path].Contains(obj.shape.type)
                && React.createElement(Button, { text: "Redraw segment", onClick: () => {
                        store.main.write.tools.redrawSegment.targetObject = obj._key;
                        store.main.write.selectedTool = "RedrawSegment";
                    } })));
    }
}
